export default __webpack_public_path__ + "images/Y5.8a14808.png";